export default __webpack_public_path__ + "static/media/manufacturer.c5121690.svg";